import { render, staticRenderFns } from "./payPage.vue?vue&type=template&id=872223a4&scoped=true"
import script from "./payPage.vue?vue&type=script&lang=js"
export * from "./payPage.vue?vue&type=script&lang=js"
import style0 from "./payPage.vue?vue&type=style&index=0&id=872223a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872223a4",
  null
  
)

export default component.exports